<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div class="view-results" *ngIf="task && experimentId">
  <h2>{{displayTypeOfResults()}}</h2>
  <ng-container *ngIf="isTaskRunning(); else noSpinner">
    <mat-spinner color="accent" [diameter]="spinnerDiameter" class="pending-results-splinner">
    </mat-spinner>
    <button mat-raised-button class="view-results-buttons" color="accent"
        (click)="cancelRunningTask()" i18n>Cancel</button>
  </ng-container>
  <ng-template #noSpinner>
    <ng-container *ngIf="isCompleted(); else cancelledOrFailed">
      <app-splitting-results [experimentId]="experimentId" [task]="task"
          *ngIf="isSplittingTask() && task.taskResult"
          [splittingResultSets]="extractSplittingResultSets().splitting_result_sets"/>
      <app-causal-impact-results
          *ngIf="isCausalImpactTask() && task.taskResult
          && extractCausalImpactResult().causal_impact_summaries?.length"
          [causalImpactResults]="extractCausalImpactResult()" [experimentId]="experimentId"
          [testGroups]="extractCausalImpactAnalysisParameters().test_groups"/>
      <app-did-results
          *ngIf="isDidTask() && task.taskResult"
          [didTaskResult]="extractDidResult()"
          [experimentId]="experimentId"
          [preExperimentStartDate]="extractDidAnalysisParameters().pre_experiment_start_date"
          [preExperimentEndDate]="extractDidAnalysisParameters().pre_experiment_end_date"
          [experimentStartDate]="extractDidAnalysisParameters().experiment_start_date"
          [experimentEndDate]="extractDidAnalysisParameters().experiment_end_date"/>
      <app-budget-simulation-results *ngIf="isBudgetSimulationTask() && task.taskResult
        && extractBudgetSimulationResult().budget_tables"
        [task]="task"
        [budgetSimulationResults]="extractBudgetSimulationResult()"
        [icpa]="extractBudgetTableParameter().icpa"
        [experimentId]="experimentId"/>
    </ng-container>
    <ng-template #cancelledOrFailed>
      <app-cancellation-and-error-message-card [task]="task" [experimentId]="experimentId" />
    </ng-template>
  </ng-template>
</div>
